import React from 'react';
import { Route } from 'react-router-dom';

export default function makeRoutes(routes) {
	return routes.map((route, i) => (
		<Route exact={route.exact} key={i} path={route.path} component={route.component}>
			{!!route.children && makeRoutes(route.children)}
		</Route>
	));
}
